export const useCartTransformAPI = (graphql, sale_page_structure) => {
    if (sale_page_structure) {
        // Parse the GraphQL query
        const parsedGraphql = graphql
        const input = parsedGraphql.variables.input;
        const lines = input.lines;

        // If cart transformation is enabled, transform the cart
        if (sale_page_structure.cartTransformEnabled) {
            // Get excluded variant IDs (items that should keep discount codes, not use cart transform)
            const excludedVariantIds = sale_page_structure.excludeFromTransform || [];

            // Check if any line item should be excluded from transform
            const hasExcludedItem = lines.some(line => {
                if (!line) return false;
                const variantId = line.merchandiseId.split('/').pop();
                return excludedVariantIds.includes(variantId);
            });

            // Only remove discount codes if there are no excluded items
            // Excluded items need their discount codes preserved
            if (!hasExcludedItem && input.discountCodes) {
                delete input.discountCodes;
            }

            // Add line item properties for price and title
            lines.forEach(line => {
                if (!line) return;

                const variantId = line.merchandiseId.split('/').pop();

                // Skip excluded items - they use discount codes, not cart transform
                if (excludedVariantIds.includes(variantId)) {
                    return;
                }

                // Skip items that already have _ctf_prc set (e.g. bonus/free items with pre-configured CTF attributes)
                if (line.attributes && Array.isArray(line.attributes) && line.attributes.some(attr => attr.key === '_ctf_prc')) {
                    return;
                }

                const itemData = sale_page_structure.items[variantId];

                if (itemData) {
                    if (!line.attributes) {
                        line.attributes = [];
                    }

                    // Add custom price property
                    line.attributes.push({
                        key: "_ctf_prc",
                        value: String(itemData.price)
                    });

                    // Add custom title property
                    line.attributes.push({
                        key: "_ctf_ttl",
                        value: itemData.storefrontTitle || ""
                    });
                }
            });

            // Add cart-level property for master product list (excluding excluded items and pre-configured bonus items)
            const masterProductList = [];
            lines.forEach(line => {
                if (!line) return;
                const variantId = line.merchandiseId.split('/').pop();
                // Skip excluded items and items with pre-set CTF attributes (bonus/free items)
                const hasPresetCtf = line.attributes && line.attributes.some(attr => attr.key === '_ctf_prc');
                if (!excludedVariantIds.includes(variantId) && !hasPresetCtf) {
                    masterProductList.push(variantId);
                }
            });

            if (!input.attributes) {
                input.attributes = [];
            }

            input.attributes.push({
                key: "_ctf_mst_prd",
                value: JSON.stringify(masterProductList)
            });
        }

        // Update the GraphQL query with transformed data
        parsedGraphql.variables.input = input;
        return JSON.stringify(parsedGraphql);
    } else {
        return JSON.stringify(graphql);
    }
}
